export default __webpack_public_path__ + "static/no_image_icon@2x-0140095b624ac367a99dcc32b67becf9.png";